var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSkipArrows = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3457 9.36914C1.58594 9.36914 1.7793 9.29297 2.01953 9.15234L7.99023 5.64258C8.30664 5.44922 8.48828 5.23828 8.55273 4.99219V8.36719C8.55273 9.02344 8.93945 9.36914 9.39648 9.36914C9.63672 9.36914 9.83594 9.29297 10.0703 9.15234L16.041 5.64258C16.3574 5.44922 16.5391 5.23828 16.6035 4.99219V8.75977C16.6035 9.27539 16.873 9.54492 17.3887 9.54492H18.7188C19.2344 9.54492 19.498 9.27539 19.498 8.75977V0.779297C19.498 0.246094 19.2344 0 18.7188 0H17.3887C16.873 0 16.6035 0.269531 16.6035 0.779297V4.54102C16.5391 4.30078 16.3633 4.08398 16.041 3.89648L10.0703 0.380859C9.83008 0.240234 9.63672 0.164062 9.39648 0.164062C8.93945 0.164062 8.55273 0.515625 8.55273 1.17188V4.54102C8.48828 4.30078 8.30664 4.08398 7.99023 3.89648L2.01953 0.380859C1.7793 0.240234 1.58594 0.164062 1.3457 0.164062C0.882812 0.164062 0.501953 0.515625 0.501953 1.17188V8.36719C0.501953 9.02344 0.882812 9.36914 1.3457 9.36914Z",
    fill: "#E5E4EC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSkipArrows);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-skip-arrows.e65d9866cd5284c83869849ee0b111a4.svg";